import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import { compose } from 'recompose'
import { Button } from 'react-toolbox/lib/button'
import * as R from 'ramda'

import withAsync from 'containers/Async/AsyncProgressBarHoc'

import {
  POST_CANCEL_PROJECT
} from 'containers/Project/View/constants'

import styles from './styles.scss'

const DialogBody = ({onCancel, onSubmit}) => {
  return (
    <div>
      <p>
        Are you sure you want to cancel the project?
      </p>
      <Flex styleName='actions' justify='flex-end'>
        <Button label='Cancel' onClick={onCancel}/>
        <Button label='Submit' onClick={onSubmit}/>
      </Flex>
    </div>
  )
}

DialogBody.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

const withStyle = CSSModules(styles)
const withProgress = R.curry((filters, component) => withAsync(component)(filters))

export default compose(
  withProgress([POST_CANCEL_PROJECT]),
  withStyle,
)(DialogBody)
